import { axiosInstance } from '../axios/axiosHandler';
import { authHeader } from '../store/auth-slice/auth-slice';

export const SvmDatabaseDownload = async (baseUrl: string) =>
{
    try
    {
        var header = authHeader();
        const response = await axiosInstance.get(baseUrl, {...header, responseType: "blob" });
        let defaultName = "UsepDB.xlsx"

        if (response.headers['content-disposition']) defaultName = response.headers['content-disposition'].split(";")[2].split("=")[1];

        if (defaultName.startsWith("UTF-8''"))
            defaultName = decodeURIComponent(defaultName.replace("UTF-8''", ''))
        else
            defaultName = defaultName.replace(/['"]/g, '')
        
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'} );
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute("download", defaultName);
        link.click();
    }
    catch(e)
    {
        console.error();
    }
}

export const SvmDatabaseUpload = async (baseUrl: string, file: File) =>
{
    try
    {
        var header = authHeader();
        var formData = new FormData();
        formData.append("file", file);
        const { data } : any = await axiosInstance.post(baseUrl, formData, {...header, headers: {...header.headers, 'Content-Type': 'multipart/form-data' } });
        return data;
    }
    catch(e)
    {
        console.error();
    }
}


export const SvmDatabaseTrain = async (baseUrl: string) =>
{
    try
    {
        var header = authHeader();
        const { data } : any = await axiosInstance.post(baseUrl, null, header);
        return data;
    }
    catch(e)
    {
        console.error();
    }
}

export const SvmGetCurrentModel = async (baseUrl: string) =>
{
    try
    {
        var header = authHeader();
        const { data } : any = await axiosInstance.get(baseUrl, header);
        return data;
    }
    catch(e)
    {
        console.error();
    }
}
